/**
 * The Wynxx mark, used wherever Atlas brands itself: the sign-in card and the
 * top of the navigation.
 *
 * It is an `<img>` rather than an inline SVG -- unlike the GFT wordmark it
 * replaces, the asset carries its own two brand blues, so it reads against
 * both the light and the dark surface with no `currentColor` trick and no
 * second asset. Serving it from `public/` also lets the same file be the
 * favicon, which is why there is only one copy of it in the build.
 */

export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      className={className ? `brand-mark ${className}` : 'brand-mark'}
      src="/wynxx-mark.svg"
      alt=""
      aria-hidden="true"
      width={140}
      height={140}
    />
  );
}
